import { render, staticRenderFns } from "./DpnIcon.vue?vue&type=template&id=45569910"
import script from "./DpnIcon.vue?vue&type=script&lang=js"
export * from "./DpnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports